import React, { useMemo } from "react";
import Modal from "react-modal";
import { FaFileExport } from "react-icons/fa";
import styles from "./RelatorioMensalidadesModal.module.css";

Modal.setAppElement("#root");

const formatValor = (v = 0) =>
  Number(v).toLocaleString("pt-PT", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const traduzStatus = (status) => {
  const map = {
    paid: "Pago",
    pending: "Pendente",
    overdue: "Vencido",
    cancelled: "Cancelado",
  };
  return map[status?.toLowerCase()] || status;
};

const RelatorioMensalidadesModal = ({ isOpen, onClose, mensalidades = [] }) => {
  // ============================= RESUMO / KPIs =============================
  const resumo = useMemo(() => {
    const total = mensalidades.length;
    const pagas = mensalidades.filter((m) => m.status === "paid").length;
    const pendentes = mensalidades.filter((m) => m.status === "pending").length;
    const vencidas = mensalidades.filter((m) => m.status === "overdue").length;

    const totalValor = mensalidades.reduce((acc, m) => acc + Number(m.valor || 0), 0);
    const totalMulta = mensalidades.reduce((acc, m) => acc + Number(m.multa || 0), 0);

    return { total, pagas, pendentes, vencidas, totalValor, totalMulta };
  }, [mensalidades]);

  // ============================= EXPORTAÇÃO =============================
  const exportar = (formato) => {
    if (!mensalidades.length) {
      alert("Nenhum dado disponível para exportação.");
      return;
    }
    alert(`Exportação em ${formato.toUpperCase()} será processada.`);
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      className={styles.modal}
      overlayClassName={styles.overlay}
    >
      <h2 className={styles.title}>Relatório de Mensalidades</h2>

      {/* ========================= RESUMO / KPIs ========================= */}
      <div className={styles.summaryGrid}>
        <div className={styles.summaryCard}>
          <strong>Total de mensalidades</strong>
          <span>{resumo.total}</span>
        </div>
        <div className={styles.summaryCard}>
          <strong>Pagas</strong>
          <span>{resumo.pagas}</span>
        </div>
        <div className={styles.summaryCard}>
          <strong>Pendentes</strong>
          <span>{resumo.pendentes}</span>
        </div>
        <div className={styles.summaryCard}>
          <strong>Vencidas</strong>
          <span>{resumo.vencidas}</span>
        </div>
        <div className={styles.summaryCard}>
          <strong>Valor total</strong>
          <span>{formatValor(resumo.totalValor)} MZN</span>
        </div>
        <div className={styles.summaryCard}>
          <strong>Total multas</strong>
          <span>{formatValor(resumo.totalMulta)} MZN</span>
        </div>
      </div>

      {/* ========================= TABELA ========================= */}
      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Código</th>
              <th>Aluno</th>
              <th>Referência</th>
              <th>Mês/Ano</th>
              <th>Valor</th>
              <th>Multa</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {!mensalidades.length && (
              <tr>
                <td colSpan="7" style={{ textAlign: "center", padding: 15 }}>
                  Nenhuma mensalidade encontrada.
                </td>
              </tr>
            )}
            {mensalidades.map((m) => (
              <tr key={m.id}>
                <td>{m.codigo}</td>
                <td>{m.aluno}</td>
                <td>{m.referencia}</td>
                <td>{m.mes}/{m.anoLetivo}</td>
                <td>{formatValor(m.valor)} MZN</td>
                <td>{formatValor(m.multa)} MZN</td>
                <td>
                  <span className={`${styles.status} ${styles[m.status?.toLowerCase()]}`}>
                    {traduzStatus(m.status)}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* ========================= BOTÕES ========================= */}
      <div className={styles.buttonsContainer}>
        <button className={styles.exportBtn} onClick={() => exportar("pdf")}>
          <FaFileExport /> Exportar PDF
        </button>
        <button className={styles.exportBtn} onClick={() => exportar("excel")}>
          <FaFileExport /> Exportar Excel
        </button>
        <button className={styles.closeBtn} onClick={onClose}>
          Fechar
        </button>
      </div>
    </Modal>
  );
};

export default RelatorioMensalidadesModal;
